import React from 'react'
import { StyledFilterTags } from '../../Styled-Components'
import {
    ACTIVITIES_LIST_ALL_TYPES, 
    UNITS_OPTIONS,
} from '../../CONSTANTS';

const ActivitiesListTags = ({
    setActivitiesValues,
    searchParams,
    updateSearchParams,
    setUnitsValues,
}) => {

    const search = searchParams.get('search') || ''
    const language_default = searchParams.get('language_default') || ''
    const isbn = searchParams.get('isbn') || ''
    const status = searchParams.get('status') || ''
    const units = searchParams.has('units') ? searchParams.get('units').split(',') : []
    const activities = searchParams.has('type') ? searchParams.get('type').split(',') : []


    const removeTag = (type, value) => {
        
        if(type === 'type' || type === 'units'){
            const valuesArray = searchParams.get(type).split(',').filter(element => element !== value)
            if(type === 'type'){
                const valuesOptionsArray = valuesArray.map((activityParam) => {
                    return ACTIVITIES_LIST_ALL_TYPES.find(option => option.value === activityParam)
                })
                setActivitiesValues(valuesOptionsArray)
            }else{
                const valuesOptionsArray = valuesArray.map((activityParam) => {
                    return UNITS_OPTIONS.find(option => option.value === activityParam)
                })
                setUnitsValues(valuesOptionsArray)
            }
            updateSearchParams(type, valuesArray.join(','))
        }else{
            updateSearchParams(type, '')
        }
    }
    return (
        <>
            {search &&
                <StyledFilterTags
                    isRemovable
                    name={search}
                    onClickRemove={() => removeTag('search')}
                />
            }
            {language_default &&
                <StyledFilterTags
                    isRemovable
                    name={`Language: ${language_default}`}
                    onClickRemove={() => removeTag('language_default')}
                />
            }
            {status &&
                <StyledFilterTags
                    isRemovable
                    name={`Status: ${status}`}
                    onClickRemove={() => removeTag('status')}
                />
            }

            {isbn &&
                <StyledFilterTags
                    isRemovable
                    name={`ISBN: ${isbn}`}
                    onClickRemove={() => removeTag('isbn')}
                />
            }

            {activities.length > 0 &&
                activities.map((activity, index) => (
                    <StyledFilterTags
                        key={`activityTag_${index}`}
                        isRemovable
                        name={`Activity Type: ${activity}`}
                        onClickRemove={() => removeTag('type', activity)}
                    />
                ))
            }

            {units.length > 0 &&
                units.map((unit, index) => (
                    <StyledFilterTags
                        key={`activityUnitTag_${index}`}
                        isRemovable
                        name={`Unit: ${unit}`}
                        onClickRemove={() => removeTag('units', unit)}
                    />
                ))
            }
            
        </>
    )
}

export default ActivitiesListTags;
